module.exports = __webpack_public_path__ + "img/blog6.9c970dcb.png";